import Axios from 'axios';
import Swiper from 'swiper/dist/js/swiper';
import PopupCardsTempl from './popup-cards.pug';
import CardPopup from '../../card/card-popup/card-popup';
// import Form from '../../form/form';
import BaseSlider from '../../baseSlider/baseSlider';
import AnimationFade from '../../../core/animation/fade/animation-fade';
import FormVue from '../../form/vue/form-vue';

export default {
  props: {
    cardsArray: {
      type: Array,
      default: () => [],
    },
    clickedIndex: {
      type: Number,
      default: 0,
    },
    buttonsArray: {
      type: Array,
      default: () => ['Предыдущее предложение', 'Следующее предложение'],
    },
    phoneText: {
      type: String,
      default: 'Позвонить',
    },
    whatsappText: {
      type: String,
      default: 'Написать в Whatsapp',
    },
    writeText: {
      type: String,
      default: 'Написать',
    },
    layoutText: {
      type: String,
      default: 'Планировка',
    },
    tourText: {
      type: String,
      default: '3D тур',
    },
    mapText: {
      type: String,
      default: 'Карта',
    },
    videoText: {
      type: String,
      default: 'Видео',
    },
  },
  template: PopupCardsTempl(),
  delimiters: ['${', '}}'],
  components: {
    CardPopup,
    AnimationFade,
    // sectionForm: Form(Object.assign(window.sectionObjectData.form, { type: '111' })),
    // sectionForm: Form(),
    BaseSlider,
    FormVue,
  },
  data() {
    return {
      needShift: false,
      startIndex: Math.max(0, this.clickedIndex - 2),
      endIndex: Math.min(this.clickedIndex + 2, this.cardsArray.length - 1),
      slider: null,
      activeName: this.cardsArray[this.clickedIndex].id,
      sectionObjectData: window.sectionObjectData,
      // sectionObjectData: this.cardsArray[this.clickedIndex].form,
      mainSlider: null,
      thumbsSlider: null,
      popupFullOpen: false,
      popupVideoOpen: false,
      fullscreenActive: 0,
      isDescrShow: false,
      sliderIndex: this.clickedIndex,
      dataForm: this.cardsArray[this.clickedIndex].form,
    };
  },
  methods: {
    CloseEvent() {
      this.$emit('close-popup');
      window.bodyLock.clearAllBodyScrollLocks();
    },
    slideTo(index) {
      if (this.slider) {
        this.slider.slideTo(index, 0, false);
      }
    },
    slideToNext() {
      if (this.slider) {
        if (this.endIndex < this.cardsArray.length) {
          this.endIndex += 1;
          this.slider.update();
          this.activeName = this.cardsArray[this.slider.activeIndex].id;
        }
      }
      this.slidersInit();
    },
    slideToPrev() {
      if (this.slider) {
        if (this.startIndex > 0) {
          this.startIndex -= 1;
          this.needShift = true;
          this.slider.update();
          this.activeName = this.cardsArray[this.slider.activeIndex - 1].id;
        }
      }
      this.slidersInit();
    },
    openFull(data) {
      this.$emit('fullscreen', data);
    },
    openVideoCard(data) {
      this.popupVideoOpen = true;
      this.$emit('popupvideo', data);
    },
    slidersInit() {
      const activeSlide = this.$el.querySelector('.popup-cards__slide.swiper-slide-active');
      this.thumbsSlider = new Swiper(activeSlide.querySelector('.baseSlider__thumb-slider'), {
        slideToClickedSlide: true,
        slidesPerView: 'auto',
      });

      const thumbs = this.thumbsSlider;

      this.mainSlider = new Swiper(activeSlide.querySelector('.baseSlider__main-slider'), {
        slidesPerView: 1,
        navigation: {
          nextEl: '.sliderButtons__btn--next',
          prevEl: '.sliderButtons__btn--prev',
        },
        thumbs: {
          swiper: thumbs,
        },
        on: {
          init() {
            if (this.slides.length <= 1) {
              if (activeSlide.querySelector('.baseSlider__slider-btns')) {
                activeSlide.querySelector('.baseSlider__slider-btns').style.display = 'none';
              }
            }
            if (thumbs !== undefined) {
              const slides = [].slice.call(thumbs.slides);
              if (slides.length > 0) {
                slides.forEach(tmp => tmp.classList.remove('baseSlider__thumb-slide--active'));
                slides[this.realIndex].classList.add('baseSlider__thumb-slide--active');
              }
              thumbs.slideTo(thumbs.realIndex);
            }
          },
          slideChange() {
            if (thumbs !== undefined) {
              const slides = [].slice.call(thumbs.slides);
              slides.forEach(tmp => tmp.classList.remove('baseSlider__thumb-slide--active'));
              slides[this.realIndex].classList.add('baseSlider__thumb-slide--active');
              thumbs.slideTo(this.realIndex);
              thumbs.activeIndex = this.realIndex;
              thumbs.clickedIndex = this.realIndex;
            }
          },
        },
      });

      this.mainSlider.params.controller.control = this.thumbsSlider;
      this.thumbsSlider.params.controller.control = this.mainSlider;
    },
    openFullPopup() {
      const popup = this.$el.querySelector('.popup-fullscreen');
      this.fullscreenActive = this.thumbsSlider.realIndex;
      window.bodyLock.disableBodyScroll(popup);
      setTimeout(() => {
        this.popupFullOpen = true;
      }, 500);
    },
    // addDataForm() {
    //   const form = this.$refs.formInPopup[this.clickedIndex].$el;
    //   if (form) {
    //     const formRadios = [...form.querySelectorAll('input[type="radio"]')];
    //     const formLabels = [...form.querySelectorAll('label')];
    //     const dataRadios = this.cardsArray[this.clickedIndex].form.radio;
    //     formRadios.forEach((input, index) => {
    //       input.setAttribute('id', dataRadios[index].id);
    //       input.setAttribute('name', dataRadios[index].name);
    //     });
    //     // formRadios.forEach((input, index) => {
    //     //   input.setAttribute('id', dataRadios[index].id);
    //     //   input.setAttribute('name', dataRadios[index].name);
    //     // });
    //     formLabels.forEach((input, index) => {
    //       input.setAttribute('for', dataRadios[index].id);
    //     });
    //   }
    // },
    changeData(array, index) {
      if (array[index] && array[index].detail_url) {
        const data = {
          query: array[index].detail_url,
        };
        Axios.post('/landing/detailinfo', data).then((response) => {
          window.dispatchEvent(new window.CustomEvent('fireMailCounter', { detail: { id: array[index].id, price: array[index].price } }));
          if (response.data && response.data.description) {
            array[index].sectionData.text.description = response.data.description;
          }
          if (response.data && response.data.layout_images) {
            if (!array[index].sectionData.slider.btns.find(c => c.id === `plan${array[index].id}`)) {
              array[index].sectionData.slider.btns.push({
                id: `plan${array[index].id}`,
                text: this.layoutText,
                name: array[index].id,
                slider: response.data.layout_images,
              });
            }
          }
          if (response.data && response.data.coords) {
            if (!array[index].sectionData.slider.btns.find(c => c.id === `map${array[index].id}`)) {
              array[index].sectionData.slider.btns.push({
                id: `map${array[index].id}`,
                text: this.mapText,
                name: array[index].id,
                map: {
                  center: {
                    coords: response.data.coords,
                    zoom: 16,
                    icon: '/icons/map-pin.svg',
                  },
                },
              });
            }
          }
          if (response.data && response.data.video) {
            if (!array[index].sectionData.slider.btns.find(c => c.id === `video${array[index].id}`)) {
              array[index].sectionData.slider.btns.push({
                id: `video${array[index].id}`,
                text: this.videoText,
                name: array[index].id,
                src: response.data.video,
              });
            }
          }
          if (response.data && response.data['3d_tour']) {
            if (!array[index].sectionData.slider.btns.find(c => c.id === `tour${array[index].id}`)) {
              array[index].sectionData.slider.btns.push({
                id: `tour${array[index].id}`,
                text: this.tourText,
                name: array[index].id,
                src: response.data['3d_tour'],
              });
            }
          }
        });
      }
    },
    declOfNum(number, words) {
      return words[(number % 100 > 4 && number % 100 < 20) ?
        2 : [2, 0, 1, 1, 1, 2][(number % 10 < 5) ?
          number % 10 : 5]];
    },
  },
  mounted() {
    const { clickedIndex } = this;
    let slideIndex = 2;
    if (clickedIndex < 2) {
      slideIndex = clickedIndex;
    }
    this.slider = new Swiper(this.$refs.newSlider, {
      slidesPerView: 'auto',
      initialSlide: slideIndex,
      centeredSlides: true,
      navigation: {
        nextEl: this.$el.querySelector('.popup-cards__btn--next'),
        prevEl: this.$el.querySelector('.popup-cards__btn--prev'),
      },
      simulateTouch: false,
      breakpoints: {
        767: {
          slidesPerView: 'auto',
          spaceBetween: 20,
          centeredSlides: true,
        },
        1023: {
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: true,
        },
      },
    });

    this.slider.on('slidePrevTransitionEnd', () => {
      if (this.needShift) {
        this.needShift = false;
        this.slider.activeIndex += 1;
        this.slider.update();
      }
    });

    this.slider.on('slideNextTransitionStart', () => {
      this.sliderIndex += 1;
      this.changeData(this.cardsArray, this.sliderIndex);
    });
    this.slider.on('slidePrevTransitionStart', () => {
      this.sliderIndex -= 1;
      this.changeData(this.cardsArray, this.sliderIndex);
    });

    this.slidersInit();
    // this.addDataForm();
    window.dispatchEvent(new window.CustomEvent('fireMailCounter', { detail: { id: this.cardsArray[this.clickedIndex].id, price: this.cardsArray[this.clickedIndex].price } }));
  },
  computed: {
    cards() {
      const cardsArraySlice = this.cardsArray.slice(this.startIndex, this.endIndex + 1);
      if (this.needShift) {
        cardsArraySlice[this.slider.activeIndex] = cardsArraySlice[this.slider.activeIndex + 1];
      }
      return cardsArraySlice;
    },
    activeNew() {
      return this.activeName;
    },
    declensionText() {
      return this.declOfNum(this.cardsArray[this.sliderIndex].sectionData.count, ['клиент', 'клиента', 'клиентов']);
    },
  },
};



// WEBPACK FOOTER //
// ./blocks/popup/cards/popup-cards.js